import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import IconArrow from "../../assets/images/icon-arrow-3.svg"
import { formatDateByString } from "../../utils/default";
import dayjs from "dayjs";

const Container = styled.div`
    width: 100%;

    .label {
        color: #2A2A2A;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
        margin-bottom: 8px;
    }

    .label-error {
        height: 16px;
        color: #F84242;
        font-size: 14px;
        font-weight: 300;
        margin-top: 4px;
    }
`;

const DropdownBox = styled.div`
    width: 100%;
    height: 40px;
    position: relative;
    background-color: #FFFFFF;
    border-radius: 30px;
    transition: all 0.2s ease;

    .dropdown-content {
        width: calc(100% - 16px);
        height: 100%;
        padding: 0px 16px 0px 0px;
        cursor: pointer;

        &.disabled {
            cursor: default;
            background-color: #B3B3B333;
        }
    }

    &.error {
        border: 1px solid #F84242 !important;
    }

    &.open {
        /* border: 1px solid #FBE250; */
    }

    .label-placeholder {
        color: #838BB4;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
    }

    .label-name {
        color: #25368D;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
    }

    .image-arrow-box {
        width: 24px;
        height: 24px;
        margin-left: auto;
        margin-right: 0px;
        border-radius: 50%;
        padding-top: 2px;
        transition: all 0.3s ease;

        .image-arrow {
            transition: all 0.3s ease;

            &.open {
                transform: rotateX(180deg);
            }
        }
    }
`;

const DropdownItemBox = styled.div`
    width: 240px;
    height: 230px;
    overflow-y: auto;
    padding: 16px;
    position: absolute;
    top: 44px;
    right: 0px;
    z-index: 9;
    border: 1px solid #B5B5B533;
    background-color: #FFFFFF;
    box-shadow: 0px 4px 4px 0px #60606012;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 2px;

    .menu {
        height: 48px;
        min-height: 48px;
        padding: 0px 8px;
        color: #505050;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.3s ease;

        &.active {
            color: #25368D;
        }

        &:hover {
            background-color: #FBE25099;
        }
    }
`;

const TabBox = styled.div`
    display: flex;
    gap: 15px;
    margin-top: 4px;

    .tab-item {
        width: 50%;
        height: 30px;
        border-radius: 23px;
        background-color: #FFFFFF;
        border: 1px solid #B5B5B5;
        cursor: pointer;
        transition: all 0.2s ease;
        color: #505050;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;

        &.active {
            background-color: #F2F5FE;
            border: 1px solid #25368D;
            color: #25368D;
            font-size: 15px;
            font-weight: 500;
            line-height: 22.43px;
        }

        &:hover {
            background-color: #F2F5FE;
        }
    }
`;

const YearBox = styled.div`
    width: 100%;
    height: calc(100% - 40px);
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &.hidden {
        display: none;
    }

    .row {
        width: 100%;
        height: 30%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .col {
            width: 30%;
            cursor: pointer;
            color: #838BB4;
            font-size: 15px;
            font-weight: 400;
            line-height: 22.43px;
            transition: all 0.1s ease;

            &.active {
                color: #25368D;
                font-size: 15px;
                font-weight: 500;
                line-height: 22.43px;
            }

            &:hover {
                color: #25368D;
            }
        }
    }
`;

const MonthBox = styled.div`
    width: 100%;
    height: calc(100% - 40px);
    margin-top: 8px;

    &.hidden {
        display: none;
    }

    .title-label {
        width: 100%;
        height: 24px;
        color: #25368D;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        cursor: pointer;
    }

    .data-box {
        width: 100%;
        height: calc(100% - 28px);
        margin-top: 4px;
    }

    .row {
        width: 100%;
        height: 30%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .col {
            width: 25%;
            cursor: pointer;
            color: #838BB4;
            font-size: 15px;
            font-weight: 400;
            line-height: 22.43px;
            transition: all 0.1s ease;

            &.active {
                color: #25368D;
                font-size: 15px;
                font-weight: 500;
                line-height: 22.43px;
            }

            &:hover {
                color: #25368D;
            }
        }
    }
`;

function CalendarCustomComponent({
    label,
    value,
    placeholder,
    disable,
    mode,
    styleContainer,
    classContainer,
    styleDropdown,
    classDropdown,
    styleDropdownItemBox,
    classDropdownItemBox,
    onSelect,
}) {
    const [selectValue, setSelectValue] = useState(null);
    const [selectValueLabel, setSelectValueLabel] = useState("");
    const [listYearBox, setListYearBox] = useState([
        {
            col: [
                { value: 0, label: "", date: null, },
                { value: 1, label: "", date: null, },
                { value: 2, label: "", date: null, },
            ]
        },
        {
            col: [
                { value: 3, label: "", date: null, },
                { value: 4, label: "", date: null, },
                { value: 5, label: "", date: null, },
            ]
        },
        {
            col: [
                { value: 6, label: "", date: null, },
                { value: 7, label: "", date: null, },
                { value: 8, label: "", date: null, },
            ]
        },
    ]);
    const [listYearMonthBox, setListYearMonthBox] = useState([
        {
            col: [
                { value: 0, label: "", date: null, },
                { value: 1, label: "", date: null, },
                { value: 2, label: "", date: null, },
            ]
        },
        {
            col: [
                { value: 3, label: "", date: null, },
                { value: 4, label: "", date: null, },
                { value: 5, label: "", date: null, },
            ]
        },
        {
            col: [
                { value: 6, label: "", date: null, },
                { value: 7, label: "", date: null, },
                { value: 8, label: "", date: null, },
            ]
        },
    ]);
    const [listMonthBox, setListMonthBox] = useState([
        {
            col: [
                { value: 0, label: "", date: null, },
                { value: 1, label: "", date: null, },
                { value: 2, label: "", date: null, },
                { value: 3, label: "", date: null, },
            ]
        },
        {
            col: [
                { value: 4, label: "", date: null, },
                { value: 5, label: "", date: null, },
                { value: 6, label: "", date: null, },
                { value: 7, label: "", date: null, },
            ]
        },
        {
            col: [
                { value: 8, label: "", date: null, },
                { value: 9, label: "", date: null, },
                { value: 10, label: "", date: null, },
                { value: 11, label: "", date: null, },
            ]
        },
    ]);
    const [valueYear, setValueYear] = useState(null);
    const [valueYearMonth, setValueYearMonth] = useState(null);
    const [labelYearMonth, setLabelYearMonth] = useState("");
    const [valueMonth, setValueMonth] = useState(null);
    const [typeCalendar, setTypeCalendar] = useState('year')
    const [yearToMonthBox, setYearToMonthBox] = useState(true)
    const [open, setOpen] = useState(false)
    const dropdownRef = useRef(null)
    const buttonDropdownRef = useRef(null)

    useEffect(() => {
        const init = async () => {
            window.addEventListener('click', eventClickOutsideDropdown)
        };
        init();

        return () => {
            window.removeEventListener('click', eventClickOutsideDropdown)
        }
    }, [])
    useEffect(() => {
        if (value?.type) {
            setTypeCalendar(value.type)
            if (value.type === "year") {
                setValueYearMonth(null)
                setValueMonth(null)
            } else if (value.type === "month") {
                setValueYear(null)
            }    
        }
        if (value?.date) {
            setSelectValue(value.date);
            let label = "";
            if (value.type === "year") {
                label = `ปี ${formatDateByString(value.date, "YYYY")}`;
                setValueYear(value.date.getFullYear())
            } else if (value.type === "month") {
                label = `ปี ${formatDateByString(value.date, "YYYY")} เดือน ${formatDateByString(value.date, "MMMM")}`;
                setValueMonth(value.date.getMonth())
                setValueYearMonth(value.date.getFullYear())
            }
            setSelectValueLabel(label)
        }
    }, [value])
    useEffect(() => {
        if (open) {
            onSetCalendar();
        } else {

        }
    }, [open])

    function eventClickOutsideDropdown(event) {
        if (dropdownRef.current
            && buttonDropdownRef.current
            && !dropdownRef.current.contains(event.target)
            && !buttonDropdownRef.current.contains(event.target)) {
            setOpen(false);
        }
    }
    function onSetCalendar() {
        let listYear = [];
        let countYear = 0;
        for (let i = 0; i < 3; i++) {
            let detailCol = {
                col: [],
            }
            for (let j = 0; j < 3; j++) {
                let date = new Date(dayjs().startOf('year'));
                date.setFullYear(date.getFullYear() - countYear);
                let detail = {
                    value: date.getFullYear(),
                    label: `ปี ${formatDateByString(date, "YYYY")}`,
                    date: date,
                }
                detailCol.col.push(detail)
                countYear++;
            }
            listYear.push(detailCol)
        }
        setListYearBox(listYear);
        // ========== ========== ========== ==========
        let listYearMonth = [];
        let countYearMonth = 0;
        for (let i = 0; i < 3; i++) {
            let detailCol = {
                col: [],
            }
            for (let j = 0; j < 3; j++) {
                let date = new Date(dayjs().startOf('year'));
                date.setFullYear(date.getFullYear() - countYearMonth);
                let detail = {
                    value: date.getFullYear(),
                    label: `ปี ${formatDateByString(date, "YYYY")}`,
                    date: date,
                }
                detailCol.col.push(detail)
                countYearMonth++;
            }
            listYearMonth.push(detailCol)
        }
        setListYearMonthBox(listYearMonth);
        setYearToMonthBox(true)
        // ========== ========== ========== ==========
        const listMonthLabel = [
            "ม.ค.",
            "ก.พ.",
            "มี.ค.",
            "เม.ย.",
            "พ.ค.",
            "มิ.ย.",
            "ก.ค.",
            "ส.ค.",
            "ก.ย.",
            "ต.ค.",
            "พ.ย.",
            "ธ.ค.",
        ];
        let listMonth = [];
        let countMonth = 0;
        for (let i = 0; i < 3; i++) {
            let detailCol = {
                col: [],
            }
            for (let j = 0; j < 4; j++) {
                let date = new Date(dayjs().startOf('year'));
                date.setMonth(date.getMonth() + countMonth);
                let detail = {
                    value: date.getMonth(),
                    label: listMonthLabel[countMonth],
                    date: date,
                }
                detailCol.col.push(detail)
                countMonth++;
            }
            listMonth.push(detailCol)
        }
        setListMonthBox(listMonth);
        // ========== ========== ========== ==========
    }

    function handleOpen() {
        if (disable) return;
        setOpen(!open)
    }
    function handleSelect(value) {
        if (disable) return;
        let rawValue = new Date(value);
        if (typeCalendar === "year") {
            setValueYear(rawValue.getFullYear())
        } else if (typeCalendar === "month") {
            rawValue.setFullYear(valueYearMonth)
            setValueMonth(rawValue.getMonth())
        }
        let detail = {
            type: typeCalendar,
            date: rawValue,
        }
        setSelectValue(detail.date)
        onSelect && onSelect(detail)
        setOpen(false)
    }
    function handleSelectYearMonthBox(param) {
        if (disable) return;

        setLabelYearMonth(`ปี ${formatDateByString(param.date, "YYYY")}`)
        setValueYearMonth(param.value)
        setYearToMonthBox(false)
    }
    async function handleSelectType(param) {
        setTypeCalendar(param)
    }

    return (
        <Container className={`${classContainer}`} style={{ ...styleContainer }}>
            {label && <div className="label">{label}</div>}
            <DropdownBox
                className={`${classDropdown} ${open ? "open" : ""}`}
                style={{ ...styleDropdown }}
            >
                <div
                    ref={buttonDropdownRef}
                    className={`dropdown-content vertical-center ${disable ? "disabled" : ""}`}
                    onClick={handleOpen}
                >
                    {selectValue ?
                        <div className="label-name">{selectValueLabel}</div>
                        :
                        <div className="label-placeholder">{placeholder || ""}</div>
                    }
                    <div className={`image-arrow-box content-center`}>
                        <img className={`image-arrow ${open ? "open" : ""}`} alt="img" src={IconArrow} />
                    </div>
                </div>
                {open &&
                    <DropdownItemBox ref={dropdownRef} className={`${classDropdownItemBox}`} style={{ ...styleDropdownItemBox }}>
                        <TabBox>
                            <div className={`content-center tab-item ${typeCalendar === 'year' ? "active" : ""}`}
                                onClick={(e) => handleSelectType('year')}>
                                รายปี
                            </div>
                            <div className={`content-center tab-item ${typeCalendar === 'month' ? "active" : ""}`}
                                onClick={(e) => handleSelectType('month')}>
                                รายเดือน
                            </div>
                        </TabBox>
                        {typeCalendar === "year" &&
                            <YearBox>
                                {listYearBox.map((valueY, indexY) => {
                                    return (
                                        <div key={indexY} className="row vertical-center">
                                            {valueY.col.map((value, index) => {
                                                return (
                                                    <div key={index}
                                                        className={`col content-center ${value.value === valueYear ? 'active' : ''}`}
                                                        onClick={(e) => handleSelect(value.date)}
                                                    >
                                                        {value.label}
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )
                                })}
                            </YearBox>
                        }
                        {typeCalendar === "month" &&
                            <>
                                <MonthBox className={`${!yearToMonthBox ? "" : "hidden"}`}>
                                    <div className="title-label content-center" onClick={(e) => { setYearToMonthBox(true) }}>
                                        {labelYearMonth}
                                    </div>
                                    <div className="data-box">
                                        {listMonthBox.map((valueY, indexY) => {
                                            return (
                                                <div key={indexY} className="row vertical-center">
                                                    {valueY.col.map((value, index) => {
                                                        return (
                                                            <div key={index}
                                                                className={`col content-center ${value.value === valueMonth ? 'active' : ''}`}
                                                                onClick={(e) => handleSelect(value.date)}
                                                            >
                                                                {value.label}
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            )
                                        })}
                                    </div>
                                </MonthBox>
                                <YearBox className={`${yearToMonthBox ? "" : "hidden"}`}>
                                    {listYearMonthBox.map((valueY, indexY) => {
                                        return (
                                            <div key={indexY} className="row vertical-center">
                                                {valueY.col.map((value, index) => {
                                                    return (
                                                        <div key={index}
                                                            className={`col content-center ${value.value === valueYearMonth ? 'active' : ''}`}
                                                            onClick={(e) => handleSelectYearMonthBox(value)}
                                                        >
                                                            {value.label}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        )
                                    })}
                                </YearBox>
                            </>
                        }
                        <div>

                        </div>
                    </DropdownItemBox>
                }
            </DropdownBox>
        </Container>
    )
}

export default CalendarCustomComponent;